import { render, staticRenderFns } from "./ModifyTaxTransfer.vue?vue&type=template&id=2259a18c&"
import script from "./ModifyTaxTransfer.vue?vue&type=script&lang=js&"
export * from "./ModifyTaxTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports